export const RESTO365_AYRTR = 'RESTO365_AYRTR'

export const RESTO365_AYRTR_ALL_FORMS = `${RESTO365_AYRTR}/getAllReadyToRollSubmittedForms`

export const RESTO365_AYRTR_ALL_FORMS_GROUPED = `${RESTO365_AYRTR}/getAllReadyToRollSubmittedFormsInGrouped`

export const RESTO365_AYRTR_GET_FORM_BY_ID = `${RESTO365_AYRTR}/gygFormBySubmissionId`

export const RESTO365_AYRTR_GET_FORM_UPLOADS_BY_ID = `${RESTO365_AYRTR}/gygFormByUploadsSubmissionId`

export const RESTO365_AYRTR_FORMS = `${RESTO365_AYRTR}/getReadyToRollForms`

export const RESTO365_AYRTR_MEDIA_UPLOADS = `${RESTO365_AYRTR}/ReadyToRollFormsMediaUploads`

export const RESTO365_AYRTR_FORMS_CREATE = `${RESTO365_AYRTR}/submitReadyToRollForms`

export const RESTO365_AYRTR_FORMS_INITIAL_STATE = `${RESTO365_AYRTR}/initialStateReadyToRollForms`

export const RESTO365_AYRTR_ALL_FORMS_SUBMISSION_BY_ID_DATE = `${RESTO365_AYRTR}/getAllReadyToRollSubmittedFormsByIdAndDate`

export const RESTO365_AYRTR_ALL_FORMS_GROUPED_DAYPART_STATS = `${RESTO365_AYRTR}/getAllReadyToRollSubmittedFormsInGroupedDayPartStats`
